import { createConfirmation } from "react-confirm";
import ZoneEditorDialog from "./ZoneEditorDialog";

export const showZoneEditorDialog = createConfirmation(ZoneEditorDialog);
